import { removeAccentuation } from './string';

// De-para idRqe -> nome da especialidade, espelhando a tabela `rqe` do banco de prescrição
// (export de 16/10/2026). O idRqe vem em `Prescriber.RQEs[].idRqe` (ou de GET /medico/:id/rqes) e o
// backend da amostra grátis recebe o nome, não o id. Ao surgir um idRqe novo no banco, incluir aqui.
// TODO: Isso aqui vai morrer, precisa vir direto do backend, pois a tabela de especialidades por RQE é dinâmica
// TASK: https://nexodata.atlassian.net/browse/NN-1473
export const RQE_SPECIALTIES: Record<number, string> = {
  1: 'GENERALISTA',
  2: 'ORTOPEDIA E TRAUMATOLOGIA',
  3: 'MEDICINA DE FAMÍLIA E COMUNIDADE',
  4: 'CLÍNICA MÉDICA',
  5: 'PEDIATRIA',
  6: 'PSIQUIATRIA',
  7: 'ONCOLOGIA CLÍNICA',
  8: 'NUTROLOGIA',
  9: 'CARDIOLOGIA',
  10: 'CIRURGIA GERAL',
  11: 'PNEUMOLOGIA',
  12: 'MEDICINA DO TRABALHO',
  13: 'DERMATOLOGIA',
  14: 'ANESTESIOLOGIA',
  15: 'GINECOLOGIA E OBSTETRÍCIA',
  16: 'CANCEROLOGIA/CANCEROLOGIA CIRÚRGICA',
  17: 'PATOLOGIA',
  18: 'ENDOCRINOLOGIA E METABOLOGIA',
  19: 'INFECTOLOGIA',
  20: 'ACUPUNTURA',
  21: 'GASTROENTEROLOGIA',
  22: 'HEMATOLOGIA E HEMOTERAPIA',
  23: 'MEDICINA DE EMERGÊNCIA',
  24: 'CIRURGIA DE CABEÇA E PESCOÇO',
  25: 'NEUROLOGIA',
  26: 'OFTALMOLOGIA',
  27: 'OTORRINOLARINGOLOGIA',
  28: 'CIRURGIA DA MÃO',
  29: 'NEUROLOGIA PEDIÁTRICA',
  30: 'GERIATRIA',
  31: 'MEDICINA DO TRÁFEGO',
  32: 'MEDICINA INTENSIVA',
  33: 'CIRURGIA DO APARELHO DIGESTIVO',
  34: 'CIRURGIA VASCULAR',
  36: 'NEFROLOGIA',
  37: 'UROLOGIA',
  38: 'HOMEOPATIA',
  39: 'MEDICINA ESPORTIVA',
  40: 'CIRURGIA PEDIÁTRICA',
  41: 'MEDICINA LEGAL E PERÍCIA MÉDICA',
  42: 'COLOPROCTOLOGIA',
  43: 'OBSTETRÍCIA',
  44: 'NEUROCIRURGIA',
  45: 'CIRURGIA PLÁSTICA',
  46: 'ALERGIA E IMUNOLOGIA',
  47: 'MASTOLOGIA',
  48: 'ENDOSCOPIA',
  49: 'CIRURGIA TORÁCICA',
  50: 'RADIOTERAPIA',
  51: 'REUMATOLOGIA',
  52: 'RADIOLOGIA E DIAGNÓSTICO POR IMAGEM',
  53: 'MEDICINA INTERNA OU CLÍNICA MÉDICA',
  54: 'HEPATOLOGIA',
  55: 'CANCEROLOGIA',
  56: 'CITOPATOLOGIA',
  57: 'ANGIOLOGIA',
  58: 'CIRURGIA CARDIOVASCULAR',
  59: 'ANGIOLOGIA E CIRURGIA VASCULAR',
  60: 'MEDICINA LEGAL',
  61: 'CIRURGIA ONCOLÓGICA',
  62: 'ENDOSCOPIA DIGESTIVA',
  63: 'ENDOCRINOLOGIA',
  64: 'CANCEROLOGIA/CANCEROLOGIA PEDIÁTRICA',
  65: 'HEMATOLOGIA',
  66: 'TERAPIA INTENSIVA',
  67: 'MEDICINA NUCLEAR',
  68: 'MEDICINA FÍSICA E REABILITAÇÃO',
  69: 'NUTRIÇÃO PARENTERAL E ENTERAL',
  70: 'MEDICINA PREVENTIVA E SOCIAL',
  71: 'GENÉTICA MÉDICA',
  72: 'DIAGNÓSTICO POR IMAGEM',
  73: 'BRONCOESOFAGOLOGIA',
  74: 'ADMINISTRAÇÃO HOSPITALAR',
  75: 'PROCTOLOGIA',
  76: 'ONCOLOGIA',
  77: 'NEUROFISIOLOGIA CLÍNICA',
  78: 'ENDOSCOPIA PERORAL',
  79: 'TISIOLOGIA',
  80: 'ELETROENCEFALOGRAFIA',
  81: 'HEMOTERAPIA',
  82: 'PATOLOGIA CLÍNICA',
  83: 'PNEUMOLOGIA E TISIOLOGIA',
  84: 'GINECOLOGIA',
  85: 'HANSENOLOGIA',
  86: 'PATOLOGIA CLÍNICA/MEDICINA LABORATORIAL',
  87: 'MEDICINA GERAL COMUNITÁRIA',
  88: 'RADIOLOGIA',
  89: 'CIRURGIA DO TRAUMA',
  90: 'FISIATRIA',
  91: 'PSIQUIATRIA INFANTIL',
  92: 'NEUROPEDIATRIA',
  93: 'GENÉTICA CLÍNICA',
  94: 'MEDICINA SANITÁRIA',
  95: 'ANATOMIA PATOLÓGICA',
  104: 'ULTRASSONOGRAFIA EM GINECOLOGIA E OBSTETRÍCIA',
  105: 'DOENÇAS INFECCIOSAS E PARASITÁRIAS',
  106: 'RADIODIAGNÓSTICO',
  107: 'GERIATRIA E GERONTOLOGIA',
  108: 'CIRURGIA VASCULAR PERIFÉRICA',
};

// Não existe na tabela do banco: é a opção usada quando o médico não tem nenhum idRqe, em vez de
// deixar o médico escrever à mão ("n/a", "s/ espec.", "generalista"...).
export const NO_SPECIALTY = 'SEM ESPECIALIDADE';

// Opções do combobox de especialidade: "SEM ESPECIALIDADE" primeiro, depois as da tabela em ordem
// alfabética.
export const SPECIALTY_OPTIONS: string[] = [
  NO_SPECIALTY,
  ...Object.values(RQE_SPECIALTIES).sort((a, b) => a.localeCompare(b, 'pt-BR')),
];

export const isValidSpecialty = (value: string): boolean => SPECIALTY_OPTIONS.includes(value);

export const getSpecialtyByRqeId = (idRqe?: string | number | null): string | undefined => {
  const id = Number(idRqe);
  return Number.isInteger(id) ? RQE_SPECIALTIES[id] : undefined;
};

// Primeiro idRqe da lista que bate com a tabela — o médico pode ter mais de um RQE.
export const findSpecialtyByRqes = (rqes?: Array<{ idRqe?: string | number | null } | null> | null): string =>
  (rqes ?? []).map((rqe) => getSpecialtyByRqeId(rqe?.idRqe)).find((name): name is string => !!name) ?? '';

const normalizeSearch = (value: string) => removeAccentuation(value).trim().toLowerCase();

// Busca sem acento e sem diferenciar maiúsculas ("clinica" acha "CLÍNICA MÉDICA").
export const filterSpecialtyOptions = (query: string): string[] => {
  const normalized = normalizeSearch(query);
  return normalized
    ? SPECIALTY_OPTIONS.filter((option) => normalizeSearch(option).includes(normalized))
    : SPECIALTY_OPTIONS;
};
